
export const formatDateString = (date) => {
    return new Date(date).toLocaleDateString()
}

export const getYear = (date) => {
    if (!date) return new Date().getFullYear();
    const d = new Date(date.trim());
    return isNaN(d) ? new Date().getFullYear() : d.getFullYear();
  };